import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-glossary",
  "use": "icon-glossary-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-glossary\"><path d=\"M11 1H5c-1.103 0-2 .897-2 2v1H2v1h1v2.5H2v1h1V11H2v1h1v1c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2V3c0-1.103-.897-2-2-2m1 12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1h1v-1H4V8.5h1v-1H4V5h1V4H4V3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z\" /><path d=\"M7.5 7h1v4h-1zm0-2h1v1h-1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol